import { DurationRangeInterface } from '../interfaces/api';

export class DurationRange implements DurationRangeInterface {

    max: number;

    min: number;

    durationFormatted(): string {
        if (this.max === undefined && !this.min === undefined) return '';
        let durationParts: string[] = [];
        let showRange = this.min !== undefined && this.max !== undefined && this.max != this.min;

        if (this.min !== undefined) {

            if (showRange) durationParts.push('Between ');

            let minDuration: number = this.min;
            let minDays: number = minDuration / (60 * 24);
            if (minDays >= 1) {
                minDays = Math.floor(minDays);
                minDuration -= minDays * 60 * 24;
                durationParts.push(minDays + 'd');
            }

            let hours: number = minDuration / 60;
            if (hours >= 1) {
                hours = Math.floor(hours);
                minDuration -= hours * 60;
                durationParts.push(hours + 'h');
            }

            let minutes: number = Math.round(minDuration);
            durationParts.push(minutes + 'mins');

            if (showRange) durationParts.push(' and ');
            else durationParts.push(' Crossing Time');
        }

        if (showRange) {
            let maxDuration: number = this.max;
            let maxDays: number = maxDuration / (60 * 24);
            if (maxDays >= 1) {
                maxDays = Math.floor(maxDays);
                maxDuration -= maxDays * 60 * 24;
                durationParts.push(maxDays + 'd');
            }

            let hours: number = maxDuration / 60;
            if (hours >= 1) {
                hours = Math.floor(hours);
                maxDuration -= hours * 60;
                durationParts.push(hours + 'h');
            }

            let minutes: number = Math.round(maxDuration);
            durationParts.push(minutes + 'mins');
            durationParts.push(' Crossing Time');
        }

        return durationParts.join(' ');
    }

    static createFromObject(object: any) {
        let range: DurationRange = new DurationRange();
        range.max = object.max;
        range.min = object.min;
        return range;
    }

}



// WEBPACK FOOTER //
// ./src/entities/duration-range.ts